import * as React from 'react'
import {createRoot} from 'react-dom/client'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom'
import 'url-polyfill'
import 'whatwg-fetch'
import {fromJust} from '@freckle/maybe'
import '@freckle/student-entities/ts/common/helpers/event-polyfill'
import '@freckle/student-entities/ts/common/helpers/queueMicrotask-polyfill'
import {AppProviders} from './app'
import {ErrorRedirect} from './common/routers/error-redirect'
import {initializeGlobalEventListeners} from './common/routers/init-global-event-listeners'
import {RouterV2} from './common/routers/router-v2'
// Important: Keep CSS import first to correctly order global CSS and CSS Modules
import './../css/frontrow.scss'

initializeGlobalEventListeners()

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppProviders />} errorElement={<ErrorRedirect />}>
      <Route path="*" element={<RouterV2 />} />
    </Route>
  )
)

const container = fromJust(document.getElementById('freckleapp'), 'Container not found')
const root = createRoot(container)
root.render(<RouterProvider router={router} />)
